import React, {Component} from "react";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import {connect} from "react-redux";
import DashboardOitSelect from "../dashboard/DashboardOitSelect";
import './CommonCreateReport.scss'
import {DropdownItem, DropdownMenu, FormGroup, Input, Label} from "reactstrap";
import oitsActions from "../../store/oits/action-creators";
import oitsSelectors from "../../store/oits/selectors";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators";
import LoadingButton from "../../../shared/ui/LoadingButton";
import trainingPhasesActions from "../../store/training-phases/action-creators";
import PhaseReportTableRow from "../training-phases/PhaseReportTableRow";

class CommonCreateReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oitGuid: null,
      selectedPhaseGuid: null,
      selectedReport: props.selfOnly ? '' : 'dor',
      isLoading: false
    }
  }

  componentDidMount() {
    this.initializeSelfOit();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.oit !== this.props.oit || prevProps.trainingPhases !== this.props.trainingPhases) {
      this.initializeSelfOit();
    }
  }

  componentWillUnmount() {
    this.finish()
  }

  initializeSelfOit() {
    if (this.props.selfOnly && this.props.oit && (!this.state.oitGuid || !this.state.selectedPhaseGuid)) {
      this.selectOit(this.props.oit.guid);
    }
  }

  selectOit(oitGuid) {
    this.setState({oitGuid}, () => {
      if (!this.props.selfOnly) {
        this.props.setSelectedOitGuid(oitGuid)
      }
      let openedPhase = this.selectedOit.trainingPhases.find(tp => tp.status === 'opened')
      if(openedPhase) {
        this.setState({
          selectedPhaseGuid: openedPhase.trainingPhaseGuid
        })
        this.props.viewTrainingPhase(openedPhase.trainingPhaseGuid)
          .then(() => {
            this.props.unmountTrainingPhases()
          })
      }
    })
  }

  selectPhase(trainingPhaseGuid) {
    this.setState({selectedPhaseGuid: trainingPhaseGuid})
    this.props.viewTrainingPhase(trainingPhaseGuid)
      .then(() => {
        this.props.unmountTrainingPhases()
      })
  }

  onAddReport() {
    this.setState({isLoading: true})
    const getResponses = () => {
      if (['dor', 'eop', 'wor'].includes(this.state.reportType)) {
        return [];
      }
      return [];
    };
    const formData = {
      formType: this.state.selectedReport,
      responses: getResponses(),
      trainingPhaseGuid: this.state.selectedPhaseGuid,
    };
    this.props.createReport(formData)
      .then((reportGuid) => {
        this.setState({isLoading: false})
        return reportGuid
      })
      .then(reportGuid => {
        this.finish()
        this.props.editReport(reportGuid)
      })
  }

  viewReport(reportGuid) {
    this.props.viewReport(reportGuid)
  }

  editReport(reportGuid) {
    this.finish()
    this.props.editReport(reportGuid);

  }

  addScheduledReport(reportGuid, type) {
    this.finish()
    this.props.addScheduledReport(reportGuid, type)
  }

  finish() {
    this.props.unmountTrainingPhases()
    this.props.onFinish && this.props.onFinish()
  }

  get filteredReports() {
    return this.props.reports ? this.props.reports
      .filter(r => {
        return (r.status === 'draft' || r.status === 'scheduled') && r.type === this.state.selectedReport
      }).sort((a, b) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime()
      }): []
  }

  get oitsInProgress() {
    return this.props.oits
      && this.props.oits.filter(o =>
        o.trainingPhases.find(tp => tp.status === 'opened'))
  }

  get selectedOit() {
    if (this.props.selfOnly) {
      return this.props.oit && {
        ...this.props.oit,
        trainingPhases: (this.props.trainingPhases || []).map(tp => ({
          ...tp,
          trainingPhaseGuid: tp.guid,
        }))
      };
    }

    return this.props.oits.find(oit => oit.guid === this.state.oitGuid)
  }

  get reportOptions() {
    return this.props.selfOnly
      ? this.props.myAvailableReports || []
      : this.props.availableReports || [];
  }

  get selectedPhase() {
    return this.selectedOit && this.selectedOit.trainingPhases.find(tp => tp.trainingPhaseGuid === this.state.selectedPhaseGuid)
  }

  render() {
    return (
      <div className="common-create-report">
        {!this.props.selfOnly && <FormGroup>
          <Label for="title">Select {this.props.oitShortLabel}</Label>
          <DashboardOitSelect
            value={this.state.oitGuid}
            onInput={(oitGuid) => this.selectOit(oitGuid)}
            expanded={false}
            multiple={false}
          />
        </FormGroup>}


        {!!this.selectedOit && <FormGroup>
          <Label for="title">Select phase</Label>
          <Input
            name="type"
            onChange={event =>
              this.selectPhase(event.target.value)
            }
            type="select"
            className="select"
            value={this.state.selectedPhaseGuid}
          >
            <option defaultValue={''}>{this.defaultLabel}</option>
            {this.selectedOit && this.selectedOit.trainingPhases.map(tp => (
              <option key={tp.trainingPhaseGuid} value={tp.trainingPhaseGuid}>{tp.header}</option>
            ))}
          </Input>
        </FormGroup>}

        {!!this.selectedOit && <FormGroup>
          <Label for="title">Select report type</Label>
          <Input
            name="type"
            onChange={event =>
              this.setState({selectedReport: event.target.value})
            }
            type="select"
            className="select"
            value={this.state.selectedReport}
          >
            <option defaultValue={''}>{this.defaultLabel}</option>
            {!this.props.selfOnly && this.props.isDorAvailable && (
              <option key="dor" value={'dor'}>Daily Observation Report</option>
            )}

            {!this.props.selfOnly && this.selectedPhase && !this.selectedPhase.hasOpenRemedial && this.props.isEopAvailable &&
              <option key="dor" value={'eop'}>End of Phase Report</option>
            }

            {this.reportOptions.map((report) => (
              <option key={report.type} value={report.type}>{report.name}</option>
            ))}

            {!this.props.selfOnly && this.selectedPhase && this.selectedPhase.hasOpenRemedial &&
              <option key="dor" value={'cont'}>Field Training Continuation</option>
            }
            {!this.props.selfOnly && this.selectedPhase && !this.selectedPhase.hasOpenRemedial && this.props.isRrtAvailable &&
              <option key="dor" value={'rrt'}>Request for Additional Training</option>
            }
          </Input>
        </FormGroup>}
        {!!this.selectedPhase && !!this.filteredReports && this.filteredReports.length > 0 && (
          <div>
            <h4>Please review the following scheduled and draft reports for this phase before creating new report</h4>
            <table>
              <tbody>
              {this.filteredReports.map((report, index) => {
                return (
                  <PhaseReportTableRow
                    key={report.guid}
                    onAddScheduledReport={(reportGuid, type) => {
                      return this.addScheduledReport(reportGuid, type);
                    }}
                    onDeleteDraftReport={(reportGuid) => {
                      return this.props.deleteDraftReport(reportGuid);
                    }}
                    onDeleteScheduledReport={(reportGuid) => {
                      return this.props.deleteScheduledReport(reportGuid);
                    }}
                    onSendReminder={reportGuid => this.onSendReminder(reportGuid)}
                    onViewReport={reportGuid => this.viewReport(reportGuid)}
                    onEditReport={reportGuid => this.editReport(reportGuid)}
                    disableView={true}
                    report={report}
                    phase={this.selectedPhase}
                  />
                );
              })}
              </tbody>
            </table>
          </div>

        )}



        {this.state.oitGuid && this.state.selectedReport && this.state.selectedPhaseGuid && (
          <LoadingButton
            onClick={() => this.onAddReport()}
            text={'Create Report'}
            icon={'fa fa-plus'}
            isLoading={this.state.isLoading}
            primary={true}
          />
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    availableReports: oitsSelectors.selectedOitAvailableReports(state),
    isEopAvailable: oitsSelectors.isEopAvailable(state),
    isDorAvailable: oitsSelectors.isDorAvailable(state),
    isRrtAvailable: oitsSelectors.isRrtAvailable(state),
    myAvailableReports: oitsSelectors.selectedMyAvailableReports(state),
    reports: state.trainingPhases.reports,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedOitGuid: (oitGuid) => {
      return dispatch(oitsActions.setSelectedOitGuid(oitGuid));
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    },
    createReport: (formData) => {
      return dispatch(trainingPhasesActionCreators.createReport(formData));
    },
    viewTrainingPhase: (phaseGuid) => {
      return dispatch(trainingPhasesActions.viewTrainingPhase(phaseGuid));
    },
    rewriteReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.rewriteReport(reportGuid));
    },
    sendReminder: (formData) => {
      return dispatch(trainingPhasesActionCreators.sendReminder(formData));
    },
    viewReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.viewReport(reportGuid));
    },
    addScheduledReport: (reportGuid, type) => {
      return dispatch(trainingPhasesActionCreators.addScheduledReport(reportGuid, type));
    },

    deleteDraftReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteDraftReport(reportGuid));
    },
    deleteScheduledReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteScheduledReport(reportGuid));
    },

    unmountTrainingPhases: () => {
      return dispatch(trainingPhasesActionCreators.closeViewTrainingPhase())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommonCreateReport);
